import { render } from "./OrdersDetails.vue?vue&type=template&id=8abc1a78&scoped=true"
import script from "./OrdersDetails.vue?vue&type=script&lang=js"
export * from "./OrdersDetails.vue?vue&type=script&lang=js"

import "./OrdersDetails.vue?vue&type=style&index=0&id=8abc1a78&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abc1a78"]])

export default __exports__